import { render, staticRenderFns } from "./return-rule-set.vue?vue&type=template&id=60228201&scoped=true&"
import script from "./return-rule-set.vue?vue&type=script&lang=ts&"
export * from "./return-rule-set.vue?vue&type=script&lang=ts&"
import style0 from "./return-rule-set.vue?vue&type=style&index=0&id=60228201&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60228201",
  null
  
)

export default component.exports